import { Divider, Text } from '@modusign/design-system';
import cx from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getHistories } from '@app/store/signingProgressInformation/selectors';

import './SignatureProgressList.scss';

interface SignatureProgressListProps {
  active: boolean;
}

function SignatureProgressList({ active }: SignatureProgressListProps) {
  const { t } = useTranslation();

  const histories = useSelector(getHistories);

  return (
    <div
      className={cx({
        'box-5x': true,
        SignatureProgressList: true,
        'SignatureProgressList--active': active,
      })}
    >
      <h5 className="space-3x">{t('SignatureProgressList-title')}</h5>
      {histories.length > 0 ? (
        <ul>
          {histories.map((history, key) => {
            const { timestamp, userIp, content } = history;
            const time = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
            return (
              // eslint-disable-next-line
              <li key={key} className="SignatureProgressList__item">
                <p className="SignatureProgressList__item-content space-1x">{content}</p>
                <p className="SignatureProgressList__item-info">
                  <small>
                    {time} /{userIp || t('SignatureProgressList-automaticProgress')}
                  </small>
                </p>
              </li>
            );
          })}
        </ul>
      ) : (
        <>
          <Divider my={6} />
          <Text color="textNeutralLight" fontSize="14px" ml={3}>
            진행 이력이 없습니다.
          </Text>
        </>
      )}
    </div>
  );
}

export default SignatureProgressList;
